import React from "react";
import InvirteText from "../images/invirteText.png";
import InvirteImage from "../images/invirteImage.png";
import { Stack } from "@mui/material";

function InvirteLogoComponent({
  direction = "row",
  width = { xs: 100, lg: 150 },
}) {
  return (
    <Stack
      sx={{
        width: width,
        alignItems: "center",
        justifyContent: direction === "column" ? "center" : "left",
        flexDirection: direction,
      }}
    >
      <img src={InvirteImage} width="30%" />
      <img src={InvirteText} width="100%" />
    </Stack>
  );
}

export default InvirteLogoComponent;
